export default __webpack_public_path__ + "static/media/Thug's Belt of Malice.bead6922.jpg";